import useHttp from '@/utils/httpClient';
import { languageSetup } from './LanguageSetup';
import { CurrencyService } from './CurrencySetup';
import { CssService } from './CssSetup';

export const setupService = () => {
  const http = useHttp();
  const languageService = languageSetup();
  const currencyService = new CurrencyService();
  const cssService = new CssService();

  const getSetup = async (lang = null) => {
    const response = await http.get('setup', { language: lang });
    const data = response.data;
    return processSetupResponse(data);
  };

  const processSetupResponse = (data) => {
    const processedData = {
      ...data,
      language: languageService.determineUserLanguage(
        data.hotel_id,
        data.languages,
      ),
      languages: languageService.processLanguages(data.languages),
      currency: currencyService.determineUserCurrency(
        data.hotel_id,
        data.currencies,
      ),
      currencySymbol: currencyService.getDefaultCurrencySymbol(data.currencies),
    };

    return processedData;
  };

  const applyCssOverride = (hotelId, hotelTemplateCss) => {
    cssService.applyCssOverride(hotelId, hotelTemplateCss);
  };

  return {
    getSetup,
    applyCssOverride,
  };
};
